import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../styles/shared';

const RequestInviteModal = ({ onClose }) => {
  const [email,   setEmail]   = useState('');
  const [reason,  setReason]  = useState('');
  const [loading, setLoading] = useState(false);
  const [done,    setDone]    = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async () => {
    if (!email.includes('@')) { setError('Please enter a valid email'); return; }
    setLoading(true); setError('');
    try {
      const res = await axios.post(`${API_URL}/api/auth/request-invite`, { email, reason });
      if (res.data.success) setDone(true);
      else setError(res.data.message || 'Something went wrong');
    } catch (e) {
      setError(e.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      {/* Backdrop */}
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }} />

      {/* Modal */}
      <div style={{ position: 'relative', width: '100%', maxWidth: '460px', background: 'rgba(8,16,32,0.98)', border: '1px solid rgba(0,255,136,0.2)', borderRadius: '20px', padding: '2.5rem', boxShadow: '0 24px 80px rgba(0,0,0,0.6)' }}>

        {/* Close */}
        <button onClick={onClose} style={{ position: 'absolute', top: '1rem', right: '1rem', background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: '1.2rem' }}>✕</button>

        {!done ? (
          <>
            <div style={{ marginBottom: '1.75rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.75rem' }}>🔐</div>
              <h2 style={{ color: '#f8fafc', fontSize: '1.4rem', fontWeight: 900, margin: '0 0 0.5rem' }}>Request an Invite</h2>
              <p style={{ color: '#64748b', fontSize: '0.875rem', margin: 0, lineHeight: 1.6 }}>
                MarketPulze is invite-only. Leave your email and we'll reach out when a spot opens.
              </p>
            </div>

            {/* Email */}
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.4rem' }}>Email Address</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                onKeyPress={e => e.key === 'Enter' && handleSubmit()}
                placeholder="you@example.com"
                style={{ width: '100%', padding: '0.85rem 1rem', background: 'rgba(15,30,60,0.6)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: '10px', color: '#f8fafc', fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }}
              />
            </div>

            {/* Optional reason */}
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '0.4rem' }}>
                How will you use it? <span style={{ color: '#334155', fontWeight: 400 }}>(optional)</span>
              </label>
              <textarea
                value={reason} onChange={e => setReason(e.target.value)}
                placeholder="e.g. Personal stock research, following S&P 500..."
                rows={3}
                style={{ width: '100%', padding: '0.85rem 1rem', background: 'rgba(15,30,60,0.6)', border: '1px solid rgba(0,212,255,0.2)', borderRadius: '10px', color: '#f8fafc', fontSize: '0.875rem', outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', lineHeight: 1.5 }}
              />
            </div>

            {error && <p style={{ color: '#ff6b6b', fontSize: '0.82rem', marginBottom: '1rem', textAlign: 'center' }}>{error}</p>}

            <button onClick={handleSubmit} disabled={loading}
              style={{ width: '100%', padding: '0.9rem', background: 'linear-gradient(135deg,#00ff88,#00d4ff)', border: 'none', borderRadius: '10px', color: '#050d1a', fontWeight: 900, fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, fontFamily: 'inherit' }}>
              {loading ? 'Submitting...' : 'Request Invite →'}
            </button>

            <p style={{ fontSize: '0.68rem', color: '#334155', textAlign: 'center', marginTop: '1rem' }}>
              We never share your email. No spam — invite notification only.
            </p>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '1rem 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ color: '#00ff88', fontSize: '1.4rem', fontWeight: 900, margin: '0 0 0.75rem' }}>You're on the list!</h2>
            <p style={{ color: '#94a3b8', fontSize: '0.9rem', lineHeight: 1.7, marginBottom: '1.5rem' }}>
              We'll email you at <strong style={{ color: '#f8fafc' }}>{email}</strong> when your invite is ready.
            </p>
            <button onClick={onClose}
              style={{ padding: '0.75rem 2rem', background: 'rgba(0,255,136,0.08)', border: '1px solid rgba(0,255,136,0.2)', borderRadius: '10px', color: '#00ff88', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              Back to MarketPulze
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestInviteModal;
